<template>
	<div class="grid grid-cols-1 gap-6 mt-6 lg:grid-cols-2 lg:gap-12">
		<div class="space-y-6">
			<OverviewProfileSummaryCard
				:summary="summaryDisplay"
				:job-offer-data="jobOfferData"
				:applicant-data="applicantData"
				:wheel-mode="wheelMode"
			/>

			<OverviewProfileInsights
				:job-offer-data="jobOfferData"
				:applicant-data="applicantData"
				:wheel-mode="wheelMode"
			/>
		</div>

		<div class="space-y-6">
			<section>
				<PersonalityWheel
					:results="applicantWheelResults"
					:applicant-results="applicantWheelResults"
					:job-offer-results="jobOfferWheelResults"
					:mode="wheelMode"
					class="max-w-[450px] mx-auto px-5"
					animated
				/>
			</section>

			<OverviewKeyTraits
				:traits="topTraitsDisplay"
				:wheel-mode="wheelMode"
			/>
		</div>
	</div>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import PersonalityWheel from '~/components/Personality/PersonalityWheel'
import OverviewKeyTraits from './OverviewKeyTraits.vue'
import OverviewProfileInsights from './OverviewProfileInsights.vue'
import OverviewProfileSummaryCard from './OverviewProfileSummaryCard.vue'

export default {
	name: 'OverviewProfileContent',
	components: {
		OverviewKeyTraits,
		OverviewProfileInsights,
		OverviewProfileSummaryCard,
		PersonalityWheel
	},
	mixins: [personalityResults],
	props: {
		jobOfferData: {
			type: Object,
			default: () => ({})
		},
		applicantData: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		applicantWheelResults() {
			return this.buildPersonalityObject(this.applicantData)
		},
		jobOfferWheelResults() {
			return this.buildPersonalityObject(this.jobOfferData)
		}
	}
}
</script>
